import axios from 'axios'
import Vue from 'vue';


export function PromiseCall(path, fun, data) {
  return new Promise((resolve, reject) => {
    nCall(path, fun, data).then(function (response) {
      var data = response.data;
      if (data.type === 'ok') { // 接口返回成功
        resolve(data.Result);
      } else {  // 接口返回失败
        reject(data.msg);
      }
    }).catch(function (error) { // 网络错误
      alert(`网络错误 ${error.response.status}`);
      reject(`网络错误：${error.response.status}`);
    });
  });
}


export function nCall(path, fun, data) {
  var params = {};
  if (data == null) {
    data = {};
  }
  if (data.params != null) {
    params = data.params;
    delete data.params;
  }
  if(fun){
    params['action'] = fun;
  }
  return axios({
    method: 'post',
    url: `/api${path}`,
    data: data,
    params: params,
    timeout: 60000,
    responseType: 'json',
  });
}


export default {
  PromiseCall
}



// WEBPACK FOOTER //
// ./src/utils/request.js